/** Cálculo dos atributos de uma unidade e dos derivados de combate. */
import { STAT_KEYS } from './types.js';
export const MAX_LEVEL = 20;
export const STAT_CAP = 30;
export const HP_CAP = 60;
export function emptyStats() {
    return { hp: 0, str: 0, mag: 0, skl: 0, spd: 0, lck: 0, def: 0, res: 0 };
}
export function addStats(a, b) {
    const out = { ...a };
    for (const key of STAT_KEYS)
        out[key] = (a[key] ?? 0) + (b[key] ?? 0);
    return out;
}
export function capStats(s) {
    const out = { ...s };
    for (const key of STAT_KEYS) {
        const cap = key === 'hp' ? HP_CAP : STAT_CAP;
        out[key] = Math.max(0, Math.min(cap, s[key]));
    }
    return out;
}
/**
 * Velocidade de ataque.
 *
 * O peso da arma só atrapalha o que ultrapassa a constituição de quem a
 * empunha: um lutador robusto carrega um machado pesado sem perder o passo, e
 * um mago franzino não. É essa conta que decide quem ataca duas vezes.
 */
export function attackSpeed(stats, weapon, con) {
    if (!weapon)
        return stats.spd;
    const burden = Math.max(0, weapon.weight - con);
    return stats.spd - burden;
}
/** Poder de ataque: força ou magia, conforme a arma, mais o poder da arma. */
export function attackPower(stats, weapon) {
    if (!weapon)
        return 0;
    return (weapon.magic ? stats.mag : stats.str) + weapon.might;
}
/** Precisão bruta, antes de descontar a esquiva do alvo. */
export function hitRate(stats, weapon) {
    if (!weapon)
        return 0;
    return weapon.hit + stats.skl * 2 + Math.floor(stats.lck / 2);
}
/** Esquiva. O terreno entra aqui — é o que faz floresta e forte valerem a pena. */
export function avoidRate(stats, weapon, con, terrain) {
    return attackSpeed(stats, weapon, con) * 2 + stats.lck + (terrain?.avoid ?? 0);
}
export function critRate(stats, weapon) {
    if (!weapon)
        return 0;
    return weapon.crit + Math.floor(stats.skl / 2);
}
/** Resistência a crítico. Sorte pura: nada mais protege de um golpe fatal. */
export function critAvoid(stats) {
    return stats.lck;
}
/** Defesa aplicável ao golpe, já com o abrigo do terreno. */
export function defenseAgainst(stats, weapon, terrain) {
    const base = weapon?.magic ? stats.res : stats.def;
    return base + (terrain?.defense ?? 0);
}
/**
 * Atributos de uma classe no nível pedido, sem sorteio.
 *
 * Serve para inimigos e para pré-visualizar uma unidade no painel: aplica o
 * crescimento como valor esperado (nível × taxa ÷ 100) em vez de rolar dado.
 * Uma unidade que sobe de nível durante a partida usa o caminho sorteado, em
 * progression.ts — os dois não devem ser confundidos.
 */
export function statsAtLevel(def, level) {
    const levels = Math.max(0, level - 1);
    const out = { ...def.bases };
    for (const key of STAT_KEYS) {
        out[key] = def.bases[key] + Math.floor((def.growths[key] * levels) / 100);
    }
    return capStats(out);
}
//# sourceMappingURL=stats.js.map